"use client";
import { ScrollToTop } from "react-simple-scroll-up";

export default function ScrollUp() {
  return <ScrollToTop symbol={"⇧"} />;
}
